// mwst 19% -> 16% vom 01.07.2020 - 31.12.2020
const startDate = new Date('2020-07-01T00:00:00+02:00');
const endDate = new Date('2021-01-01T00:00:00+01:00');

const isSpecialTaxRate = date => {
    if (!date) {
        date = new Date();
    } else if (!date instanceof Date) {
        date = new Date(date);
    }
    return startDate <= date && date <= endDate;
};

export const taxLabel = function (date) {
    if (isSpecialTaxRate(date)) {
        return '16%';
    }
    return '19%';
};
